// Reveal-on-scroll — adiciona `.in` em qualquer elemento `.reveal`
// quando entra no viewport. Uma única IO compartilhada por todas as
// sections. Unobserve após primeira aparição para liberar memória.

export function initReveal(): void {
  const targets = Array.from(document.querySelectorAll<HTMLElement>(".reveal"));
  if (targets.length === 0) return;

  // Respeita reduced-motion: pula animação, apenas marca como visível.
  const reduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced) {
    for (const el of targets) el.classList.add("in");
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      }
    },
    { threshold: 0.12 },
  );
  for (const el of targets) io.observe(el);
}
